/*
 * @Author: xiaolong.xu
 * @Date: 2023-09-12 11:29:05
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-09-12 11:34:03
 * @Description: file content
 */
export const EVENT_NAME = {
  FIRST_CLAIM: Symbol('FIRST_CLAIM'), // 首次领取14天会员
}
